function axiosConfig() {
    const headers = {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
    };
    const config = {
        headers,
        mode: "cors"
    };

    return config;
}

function axiosResponseError(source, response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log(`${source} error`);
    console.log(`Network error ${response.data}`);
    console.log(`Network error ${response.status}`);
    console.log(`Network error ${response.headers}`);

    if (response.status == 401) { // unauthorised
        window.location.href = "/";
    } else  if (response.status == 403) { // forbidden
        alert(`${source}. Access forbidden`);
    } else {
        alert(`${source}. Error: ${response.status} - ${response.statusText}`);
    }
}

function axiosError(source, axios, error, showGeneral = true) {
    if (axios.isCancel(error)) {
        // do nothing, as the call was cancelled
    } else if (error.response) {
        axiosResponseError(source, error.response);
    } else if ((error.code == "ERR_NETWORK") ?? false) {
        console.log(`Response error ${error.code} ${error.message}`);
        alert(`${source}. Network error ${error.code} ${error.message}`);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(`${source}. Request error ${JSON.stringify(error.request)}`);
        if (!isUserAborted(error.request)) {
            alert(`${source}. Request Error: ${JSON.stringify(error.request)}`);
        }
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log(`${source}. General error ${error.message}`);
        if (showGeneral) {
            alert(`${source}. General Error: ${error.message}`);
        }
    }
}

function isUserAborted(xhr) {
    return !xhr.getAllResponseHeaders();
}


export {
    axiosConfig,
    axiosError,
    isUserAborted
};